import {MouseEventHandler} from 'react';
import {ReactNode} from 'react';

import cn from 'classnames';

import {ButtonLinkMods, ButtonLinkSize, ButtonSize} from './ButtonLink';

import s from './ButtonLink.module.css';

export interface ButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  mod?: ButtonLinkMods;
  href?: string;
  title?: string;
  dataQa?: string;
  className?: string;
  children?: ReactNode;
  isDisabled?: boolean;
  size?: ButtonLinkSize;
  type?: 'button' | 'submit';
}

export function Button({
  mod = ButtonLinkMods.ButtonYellow,
  title,
  className,
  children,
  isDisabled,
  dataQa,
  size = undefined,
  type = 'button',
  onClick,
}: ButtonProps): JSX.Element {
  return (
    <button
      className={cn(
        s[`root_${mod}`],
        {
          [s.sizeL]: size === ButtonSize.L,
          [s.sizeM]: size === ButtonSize.M,
          [s.sizeS]: size === ButtonSize.S,
          [s.sizeXS]: size === ButtonSize.XS,
        },
        className,
      )}
      onClick={onClick}
      onTouchStart={() => {}}
      type={type}
      disabled={isDisabled}
      title={title}
      aria-label={title}
      data-qa={dataQa}
    >
      {children}
    </button>
  );
}
